up.compiler('.ts-control .item', (element) => {
  /* Allow the user to remove multi-items with a mouse click */
  up.on(element, 'click', '.item--remove', () => {
    up.emit(element.closest('.ts-wrapper'), 'item:removed', { id: element.dataset.value })
  })
})
